// extracted by mini-css-extract-plugin
module.exports = {"flex":"Sticker_flex__Rk_zw","item":"Sticker_item__0_TlR","active":"Sticker_active___B9th"};